import { render, staticRenderFns } from "./NomenclatureEditCard.vue?vue&type=template&id=f07c9c2a&scoped=true"
import script from "./NomenclatureEditCard.vue?vue&type=script&lang=js"
export * from "./NomenclatureEditCard.vue?vue&type=script&lang=js"
import style0 from "./NomenclatureEditCard.vue?vue&type=style&index=0&id=f07c9c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07c9c2a",
  null
  
)

export default component.exports